<template>
  <div>
    <md-app-toolbar>
      <div class="md-toolbar-row">
        <BuildingStockHeader />
      </div>
    </md-app-toolbar>
    <div class="page-container">
      <md-app
        md-mode="fixed">

        <md-app-content class="page-content">
          <div class="page-layout">
            <div class="main__panel">
              <md-content>
                <md-tabs @md-changed="tabChanged">
                  <md-tab
                    id="tab-diagramm"
                    md-label="Diagramme"
                    md-icon="bubble_chart" />
                  <md-tab
                    id="tab-map"
                    md-label="Carte"
                    md-icon="map" />
                </md-tabs>

                <div v-if='displayMode === "diagramm"'>
                  <h2>Performance du parc selon la consommation</h2>
                  <md-card
                    class="md-elevation-30">
                    <md-card-content>
                      <BubbleChart
                        :options="consumptionChart.chartOptions"
                        :chart-data="consumptionChart.dataCollection"
                        :gen-legend="false"
                        chart-id="id-consumptions-chart"
                        :width="800"
                        :height="450"
                        ref="consumptionChart" />

                      <md-button
                        class="md-raised md-primary"
                        @click="resetChartZoom('consumptionChart')">
                        <md-icon>search</md-icon>
                        Réinitialiser le zoom
                      </md-button>
                      <md-button
                        class="md-raised md-primary"
                        @click="legendDPEDialog.isOpen = true">
                        <md-icon>label</md-icon>
                        Afficher la légende DPE
                      </md-button>
                    </md-card-content>
                  </md-card>

                  <h2>Performance du parc selon les dépenses en Euros</h2>
                  <md-card
                    class="md-elevation-30">
                    <md-card-content>
                      <BubbleChart
                        :options="outgoingsChart.chartOptions"
                        :chart-data="outgoingsChart.dataCollection"
                        :gen-legend="false"
                        chart-id="id-outgoings-chart"
                        :width="800"
                        :height="450"
                        ref="outgoingsChart" />
                      <md-button
                        class="md-raised  md-primary"
                        @click="resetChartZoom('outgoingsChart')">
                        <md-icon>search</md-icon>
                        Réinitialiser le zoom
                      </md-button>
                      <md-button
                        class="md-raised md-primary"
                        @click="legendDPEDialog.isOpen = true">
                        <md-icon>label</md-icon>
                        Afficher la légende DPE
                      </md-button>
                    </md-card-content>
                  </md-card>
                </div>
                <div v-if='displayMode === "map"'>
                  <h2>Performance du parc selon la consommation</h2>
                  <building-stock-map
                    name="consumption"
                    :data="chartData"
                    :get-radius="getRadius"
                    :get-color="getConsumptionColor" />

                  <h2>Performance du parc selon les dépenses en Euros</h2>
                  <building-stock-map
                    name="cost"
                    :data="chartData"
                    :get-radius="getRadius"
                    :get-color="getCostColor" />
                </div>
              </md-content>
            </div>
            <div class="filters__panel">
              <template>
                <div>
                  <md-content
                    class="md-elevation-3 p-10">
                    <div class="md-caption">Sélection</div>
                    <div>{{ metaDatas.selectedPlaces }} bâtiments / <em>{{ metaDatas.totalPlaces }}</em></div>
                    <div>{{ metaDatas.selectedSHON|formatIntNumber }} m² SHON / <em>{{ metaDatas.totalSHON|formatIntNumber }}</em></div><br>
                    <div class="md-caption">Consommations (corrigées du climat)</div>
                    <div>{{ metaDatas.selectedPrimaryEnergyConsumption|formatIntNumber }} kWhEP / <em>{{ metaDatas.totalPrimaryEnergyConsumption|formatIntNumber }}</em></div>
                    <div>{{ metaDatas.selectedPrimaryEnergyConsumptionPerArea|formatIntNumber }} kWhEP/m² SHON / <em>{{ metaDatas.totalPrimaryEnergyConsumptionPerArea|formatIntNumber }}</em></div><br>
                    <div class="md-caption">Dépenses</div>
                    <div>{{ metaDatas.selectedTotalCost|formatIntNumber }} € / <em>{{ metaDatas.totalTotalCost|formatIntNumber }}</em></div>
                  </md-content>

                  <h3>Année</h3>
                  <md-field>
                    <md-select
                      v-model="displayFilters.selectedYear"
                      name="year"
                      required>
                      <md-option
                        v-for="year in yearsList"
                        :key='year'
                        :value="year">{{ year }}</md-option>
                    </md-select>
                  </md-field>
                </div>
                <div>
                  <h3>
                    <md-checkbox
                      class="md-primary"
                      v-model="selectedAllFunctions">
                      Fonctions
                    </md-checkbox>
                  </h3>
                  <div
                    v-for="func in functionsList"
                    :key="func.id">
                    <md-checkbox
                      class="md-primary"
                      :value="func.id"
                      v-model="displayFilters.selectedFunctions">
                      {{ func.label }} ({{ func.places_count }})
                    </md-checkbox>
                  </div>
                </div>
                <div>
                  <h3>
                    <md-checkbox
                      class="md-primary"
                      v-model="selectedAllEnergies">
                      Énergie de chauffage
                    </md-checkbox>
                  </h3>
                  <div
                    v-for="energy in energiesList"
                    :key="energy.id">
                    <md-checkbox
                      class="md-primary"
                      :value="energy.id"
                      v-model="displayFilters.selectedEnergies">
                      {{ energy.label }}
                    </md-checkbox>
                  </div>
                </div>
                <div
                  v-if='tagsList.length > 0'>
                  <h3>Tags</h3>
                  <div
                    v-for="tag in tagsList"
                    :key="tag.id">
                    <md-checkbox
                      class="md-primary"
                      :value="tag.id"
                      v-model="displayFilters.selectedTags">
                      {{ tag.name }}
                    </md-checkbox>
                  </div>
                </div>
              </template>
            </div>
          </div>
        </md-app-content>
      </md-app>

      <md-dialog
        :md-active.sync="legendDPEDialog.isOpen"
        :md-fullscreen="false">
        <md-dialog-title>Légendes DPE</md-dialog-title>

        <md-dialog-content>
          <md-field>
            <label for="building_type">Type de bâtiment</label>
            <md-select
              name="building_type"
              v-model="legendDPEDialog.buildingTypeChoice"
              id="building_type">
              <md-option value="offices">Bureaux, administratifs, enseignement</md-option>
              <md-option value="gym">Gymnases, musées, salles de spectacle</md-option>
              <md-option value="continued-occupation">Occupation continue</md-option>
              <md-option value="housing">Logement</md-option>
            </md-select>
          </md-field>
          <img
            src="static/dpe_bureau_admin_enseignement.png"
            v-if="legendDPEDialog.buildingTypeChoice === 'offices'">
          <img
            src="static/dpe_autres-batiments.png"
            v-if="legendDPEDialog.buildingTypeChoice === 'gym'">
          <img
            src="static/dpe_occupation-continue.png"
            v-if="legendDPEDialog.buildingTypeChoice === 'continued-occupation'">
          <img
            src="static/dpe_logement.png"
            v-if="legendDPEDialog.buildingTypeChoice === 'housing'">
        </md-dialog-content>

        <md-dialog-actions>
          <md-button @click="legendDPEDialog.isOpen = false">
            Fermer
          </md-button>
        </md-dialog-actions>
      </md-dialog>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import router from '../router/index'
import {consumptionClassColors, mapMarkerSizes} from '../constants'
import session from '../api/session'
import BuildingStockHeader from '../components/BuildingStockHeader.vue'
import BuildingStockMap from '../components/BuildingStockMap.vue'
import BuildingStockPopup from '../components/BuildingStockPopup'
import BubbleChart from '../components/BubbleChart.vue'
import ChartValuesMixin from '../mixins/ChartValuesMixin'
import ValuesDisplayMixin from '../mixins/ValuesDisplayMixin'
import Rainbow from 'rainbowvis.js'
var _ = require('lodash')

export default {
  name: 'BuildingStockSummary',
  mixins: [ChartValuesMixin, ValuesDisplayMixin],
  components: { BuildingStockHeader, BubbleChart, BuildingStockMap },
  data () {
    return {
      displayMode: 'diagramm',
      yearsList: [],
      functionsList: [],
      energiesList: [],
      tagsList: [],
      chartData: [],
      metaDatas: {
        totalPlaces: 0,
        selectedPlaces: 0,
        totalSHON: 0,
        selectedSHON: 0,
        totalPrimaryEnergyConsumption: 0,
        selectedPrimaryEnergyConsumption: 0,
        totalPrimaryEnergyConsumptionPerArea: 0,
        selectedPrimaryEnergyConsumptionPerArea: 0,
        totalTotalCost: 0,
        selectedTotalCost: 0
      },
      selectedAllFunctions: true,
      selectedAllEnergies: true,
      displayFilters: {
        selectedYear: null,
        selectedFunctions: [],
        selectedEnergies: [],
        selectedTags: []
      },
      consumptionChart: {
        dataCollection: {},
        chartOptions: {},
        aConsumptionData: [],
        bConsumptionData: [],
        cConsumptionData: [],
        dConsumptionData: [],
        eConsumptionData: [],
        fConsumptionData: [],
        gConsumptionData: []
      },
      outgoingsChart: {
        dataCollection: {},
        chartOptions: {},
        outgoingsData: []
      },
      legendDPEDialog: {
        isOpen: false,
        buildingTypeChoice: 'offices'
      }
    }
  },
  created: function () {
    // _.debounce est une fonction fournie par lodash pour limiter la fréquence
    // d'exécution d'une opération particulièrement couteuse.
    // Pour en savoir plus sur la fonction `_.debounce` (et sa cousine
    // `_.throttle`), visitez : https://lodash.com/docs#debounce
    this.debouncedGetChartData = _.debounce(this.getChartData, 1000)
  },
  mounted: function () {
    var app = this
    app.$store.dispatch('routing/update_title', 'Parc bâti')
    app.$store.dispatch('routing/update_return_kwargs', null)
    app.loadApi()
  },
  computed: {
  },
  watch: {
    selectedAllFunctions: function (val) {
      var app = this
      app.displayFilters.selectedFunctions = []

      if (val === true) {
        for (var i in app.functionsList) {
          app.displayFilters.selectedFunctions.push(app.functionsList[i]['id'])
        }
      }
    },
    selectedAllEnergies: function (val) {
      var app = this
      app.displayFilters.selectedEnergies = []

      if (val === true) {
        app.energiesList.forEach(function (e) {
          app.displayFilters.selectedEnergies.push(e.id)
        })
      }
    },
    displayFilters: {
      handler (val) {
        this.debouncedGetChartData()
      },
      deep: true
    }
  },
  methods: {
    resetChartZoom: function (ref) {
      this.$refs[ref]._data._chart.resetZoom()
    },
    tabChanged: function (activeTab) {
      var app = this

      switch (activeTab) {
        case 'tab-diagramm':
          app.displayMode = 'diagramm'
          break
        case 'tab-map':
          app.displayMode = 'map'
          break
      }
    },
    genChartTooltips: function (chartId) {
      var app = this

      return {
        enabled: false,
        mode: 'nearest',
        callbacks: {
          title: function (tooltipItems, data) {
            if (tooltipItems.length > 0) {
              var tooltipItem = tooltipItems[0]
              var dataset = data.datasets[tooltipItem.datasetIndex]
              var pointData = dataset.data[tooltipItem.index]
              var originalData = pointData.originalData
              return app.placeChoiceName(originalData.place_details)
            } else {
              return ''
            }
          },
          label: function (tooltipItem, data) {
            var dataset = data.datasets[tooltipItem.datasetIndex]
            var pointData = dataset.data[tooltipItem.index]
            var originalData = pointData.originalData
            return originalData
          }
        },
        custom: function (tooltipModel) {
          // Tooltip Element
          var tooltipEl = document.querySelector('#' + chartId + ' #chartjs-tooltip')

          // Create element on first render
          if (!tooltipEl) {
            tooltipEl = document.createElement('div')
            tooltipEl.id = 'chartjs-tooltip'
            tooltipEl.innerHTML = '<div id="id_wrapper"></div>'
            document.getElementById(chartId).appendChild(tooltipEl)
          }

          // Hide if no tooltip
          if (tooltipModel.opacity === 0) {
            tooltipEl.style.display = 'none'
            return
          }

          // Set caret Position
          tooltipEl.classList.remove('above', 'below', 'no-transform')
          if (tooltipModel.yAlign) {
            tooltipEl.classList.add(tooltipModel.yAlign)
          } else {
            tooltipEl.classList.add('no-transform')
          }

          function getBody (bodyItem) {
            return bodyItem.lines
          }

          // Set Text
          if (tooltipModel.body) {
            var bodyLines = tooltipModel.body.map(getBody)
            var originalData = bodyLines[0][0]
            var placeDetails = originalData.place_details

            let popup = BuildingStockPopup
            popup['router'] = router
            let Popup = Vue.extend(popup)
            let instance = new Popup({
              propsData: {
                popupData: {
                  title: app.placeChoiceName(placeDetails),
                  place: {
                    id: placeDetails.parent,
                    locality: placeDetails.locality,
                    function: placeDetails.function,
                    ownershipStatus: placeDetails.ownership_status
                  },
                  shon: originalData.shon,
                  nbAreas: originalData.nb_areas,
                  year: originalData.year,
                  primaryEnergyConsumption: originalData.primary_energy_consumption,
                  totalCost: originalData.total_cost
                }
              }
            })

            instance.$mount()

            var tableRoot = tooltipEl.querySelector('#id_wrapper')
            tableRoot.innerHTML = instance.$el.innerHTML
          }

          // Display, position, and set styles for font
          tooltipEl.style.display = 'block'
          tooltipEl.style.position = 'absolute'
          tooltipEl.style.right = '40px'
          tooltipEl.style.top = '30px'
          tooltipEl.style.backgroundColor = 'white'
          tooltipEl.style.fontFamily = tooltipModel._bodyFontFamily
          tooltipEl.style.fontSize = tooltipModel.bodyFontSize + 'px'
          tooltipEl.style.fontStyle = tooltipModel._bodyFontStyle
          tooltipEl.style.padding = '10px'
          tooltipEl.style.boxShadow = '0 0px 46px -5px #8888888a'
        }
      }
    },
    getChartData: function () {
      var app = this
      var dotsRadius = 6
      app.$store.dispatch('loading/begin_loading')

      var queryParams = {
        year: app.displayFilters.selectedYear
      }

      if (app.displayFilters.selectedEnergies.length !== app.energiesList.length) {
        queryParams.energies = app.displayFilters.selectedEnergies
      }

      if (app.displayFilters.selectedFunctions.length !== app.functionsList.length) {
        queryParams.functions = app.displayFilters.selectedFunctions
      }

      if (app.displayFilters.selectedTags.length > 0) {
        queryParams.tags = app.displayFilters.selectedTags
      }

      session.get('/api/userdata/place-annual-primary-energy-consumption/', {params: queryParams}).then(function (chartResponse) {
        app.metaDatas.totalPlaces = chartResponse.data.total_places
        app.metaDatas.selectedPlaces = chartResponse.data.selected_places

        app.metaDatas.totalSHON = parseInt(chartResponse.data.total_shon)
        app.metaDatas.selectedSHON = parseInt(chartResponse.data.selected_shon)

        app.metaDatas.totalPrimaryEnergyConsumption = parseInt(chartResponse.data.total_primary_energy_consumption)
        app.metaDatas.selectedPrimaryEnergyConsumption = parseInt(chartResponse.data.selected_primary_energy_consumption)

        app.metaDatas.totalPrimaryEnergyConsumptionPerArea = parseInt(chartResponse.data.total_primary_energy_consumption_per_area)
        app.metaDatas.selectedPrimaryEnergyConsumptionPerArea = parseInt(chartResponse.data.selected_primary_energy_consumption_per_area)

        app.metaDatas.totalTotalCost = parseInt(chartResponse.data.total_total_cost)
        app.metaDatas.selectedTotalCost = parseInt(chartResponse.data.selected_total_cost)

        app.chartData = chartResponse.data.results

        //  The exact max consumptionsMaxY value
        var originalConsumptionMaxY = Math.max.apply(Math, app.chartData.map(function (o) { return o.primary_energy_consumption }))

        var yConsumptionsAxisMax = app.getAxisMax(originalConsumptionMaxY)
        var consumptionsMaxY = yConsumptionsAxisMax.max
        var yConsumptionsStep = yConsumptionsAxisMax.step

        //  The exact max SHON value
        var originalMaxSHON = Math.max.apply(Math, app.chartData.map(function (o) { return o.shon }))

        var SHONAxisMax = app.getAxisMax(originalMaxSHON)
        var xMaxSHON = SHONAxisMax.max
        var xMaxSHONStep = SHONAxisMax.step

        //  The exact max outgoingsMaxY value
        var originalOutgoingsMaxY = Math.max.apply(Math, app.chartData.map(function (o) { return o.total_cost }))

        var yOutgoingsAxisMax = app.getAxisMax(originalOutgoingsMaxY)
        var outgoingsMaxY = yOutgoingsAxisMax.max
        var yOutgoingsStep = yOutgoingsAxisMax.step

        // Re-init data tables
        app.outgoingsChart.outgoingsData = []
        app.consumptionChart.aConsumptionData = []
        app.consumptionChart.bConsumptionData = []
        app.consumptionChart.cConsumptionData = []
        app.consumptionChart.dConsumptionData = []
        app.consumptionChart.eConsumptionData = []
        app.consumptionChart.fConsumptionData = []
        app.consumptionChart.gConsumptionData = []

        app.chartData.forEach(function (data) {
          app.outgoingsChart.outgoingsData.push({x: data.shon, y: data.total_cost, r: dotsRadius, originalData: data})

          switch (data.energy_class_level) {
            case 'A':
              app.consumptionChart.aConsumptionData.push({x: data.shon, y: data.primary_energy_consumption, r: dotsRadius, originalData: data})
              break

            case 'B':
              app.consumptionChart.bConsumptionData.push({x: data.shon, y: data.primary_energy_consumption, r: dotsRadius, originalData: data})
              break

            case 'C':
              app.consumptionChart.cConsumptionData.push({x: data.shon, y: data.primary_energy_consumption, r: dotsRadius, originalData: data})
              break

            case 'D':
              app.consumptionChart.dConsumptionData.push({x: data.shon, y: data.primary_energy_consumption, r: dotsRadius, originalData: data})
              break

            case 'E':
              app.consumptionChart.eConsumptionData.push({x: data.shon, y: data.primary_energy_consumption, r: dotsRadius, originalData: data})
              break

            case 'F':
              app.consumptionChart.fConsumptionData.push({x: data.shon, y: data.primary_energy_consumption, r: dotsRadius, originalData: data})
              break

            case 'G':
              app.consumptionChart.gConsumptionData.push({x: data.shon, y: data.primary_energy_consumption, r: dotsRadius, originalData: data})
              break
          }
        })

        // Consumptions chart
        app.consumptionChart.chartOptions = {
          responsive: true,
          maintainAspectRatio: false,
          title: {display: true, text: 'Répartition du parc en termes de consommation primaire (corrigé du climat)'},
          legend: {position: 'bottom', labels: {usePointStyle: true, padding: 20, fontStyle: 'bold'}},
          layout: {
            padding: {
              left: 0,
              right: 0,
              top: 10,
              bottom: 0
            }
          },
          scales: {
            xAxes: [ {
              id: 'x-axis-shon',
              scaleLabel: {
                display: true,
                labelString: 'SHON (m²)',
                fontFamily: 'Montserrat',
                fontColor: 'black',
                fontStyle: 'bold'
              },
              stacked: true,
              ticks: {
                beginAtZero: true,
                min: 0,
                max: xMaxSHON,
                stepSize: xMaxSHONStep
              },
              position: 'right',
              type: 'linear'
            }],
            yAxes: [{
              id: 'y-axis-consumptions',
              scaleLabel: {
                display: true,
                labelString: 'Consommation annuelle (kWhep)',
                fontFamily: 'Montserrat',
                fontColor: 'black',
                fontStyle: 'bold'
              },
              ticks: {
                beginAtZero: true,
                min: 0,
                max: consumptionsMaxY,
                stepSize: yConsumptionsStep
              },
              position: 'left',
              type: 'linear'
            }]
          },
          plugins: {
            zoom: {
              pan: {
                enabled: true,
                mode: 'xy',
                rangeMin: {
                  x: 0,
                  y: 0
                },
                rangeMax: {
                  x: xMaxSHON,
                  y: consumptionsMaxY
                }
              },
              zoom: {
                enabled: true,
                drag: false,
                mode: 'xy',
                rangeMin: {
                  x: 0,
                  y: 0
                },
                rangeMax: {
                  x: xMaxSHON,
                  y: consumptionsMaxY
                }
              }
            }
          },
          tooltips: app.genChartTooltips('id-consumptions-chart-wrapper')
        }

        app.consumptionChart.dataCollection = {
          datasets: [
            {
              label: 'A',
              data: app.consumptionChart.aConsumptionData,
              backgroundColor: consumptionClassColors['A'],
              pointStyle: 'rectRot',
              xAxisID: 'x-axis-shon',
              yAxisID: 'y-axis-consumptions'
            },
            {
              label: 'B',
              data: app.consumptionChart.bConsumptionData,
              backgroundColor: consumptionClassColors['B'],
              pointStyle: 'rectRot',
              xAxisID: 'x-axis-shon',
              yAxisID: 'y-axis-consumptions'
            },
            {
              label: 'C',
              data: app.consumptionChart.cConsumptionData,
              backgroundColor: consumptionClassColors['C'],
              pointStyle: 'rectRot',
              xAxisID: 'x-axis-shon',
              yAxisID: 'y-axis-consumptions'
            },
            {
              label: 'D',
              data: app.consumptionChart.dConsumptionData,
              backgroundColor: consumptionClassColors['D'],
              pointStyle: 'rectRot',
              xAxisID: 'x-axis-shon',
              yAxisID: 'y-axis-consumptions'
            },
            {
              label: 'E',
              data: app.consumptionChart.eConsumptionData,
              backgroundColor: consumptionClassColors['E'],
              pointStyle: 'rectRot',
              xAxisID: 'x-axis-shon',
              yAxisID: 'y-axis-consumptions'
            },
            {
              label: 'F',
              data: app.consumptionChart.fConsumptionData,
              backgroundColor: consumptionClassColors['F'],
              pointStyle: 'rectRot',
              xAxisID: 'x-axis-shon',
              yAxisID: 'y-axis-consumptions'
            },
            {
              label: 'G',
              data: app.consumptionChart.gConsumptionData,
              backgroundColor: consumptionClassColors['G'],
              pointStyle: 'rectRot',
              xAxisID: 'x-axis-shon',
              yAxisID: 'y-axis-consumptions'
            }
          ]
        }

        // OutGoingsChart
        app.outgoingsChart.chartOptions = {
          responsive: true,
          maintainAspectRatio: false,
          title: {display: true, text: 'Répartition du parc en termes de dépense totale'},
          legend: {display: false},
          layout: {
            padding: {
              left: 0,
              right: 0,
              top: 10,
              bottom: 0
            }
          },
          scales: {
            xAxes: [ {
              id: 'x-axis-shon',
              scaleLabel: {
                display: true,
                labelString: 'SHON (m²)',
                fontFamily: 'Montserrat',
                fontColor: 'black',
                fontStyle: 'bold'
              },
              stacked: true,
              ticks: {
                beginAtZero: true,
                min: 0,
                max: xMaxSHON,
                stepSize: xMaxSHONStep
              },
              position: 'right',
              type: 'linear'
            }],
            yAxes: [{
              id: 'y-axis-outgoings',
              scaleLabel: {
                display: true,
                labelString: 'Dépenses annuelles (€)',
                fontFamily: 'Montserrat',
                fontColor: 'black',
                fontStyle: 'bold'
              },
              ticks: {
                beginAtZero: true,
                min: 0,
                max: outgoingsMaxY,
                stepSize: yOutgoingsStep
              },
              position: 'left',
              type: 'linear'
            }]
          },
          plugins: {
            zoom: {
              pan: {
                enabled: true,
                mode: 'xy',
                rangeMin: {
                  x: 0,
                  y: 0
                },
                rangeMax: {
                  x: xMaxSHON,
                  y: outgoingsMaxY
                }
              },
              zoom: {
                enabled: true,
                drag: false,
                mode: 'xy',
                rangeMin: {
                  x: 0,
                  y: 0
                },
                rangeMax: {
                  x: xMaxSHON,
                  y: outgoingsMaxY
                }
              }
            }
          },
          tooltips: app.genChartTooltips('id-outgoings-chart-wrapper')
        }

        app.outgoingsChart.dataCollection = {
          datasets: [
            {
              data: app.outgoingsChart.outgoingsData,
              backgroundColor: '#5BAFD7',
              borderColor: '#FFFFFF',
              borderWidth: 2,
              pointStyle: 'circle',
              xAxisID: 'x-axis-shon',
              yAxisID: 'y-axis-outgoings'
            }
          ]
        }
      }).then(function (response) {
        app.$store.dispatch('loading/end_loading')
      })
    },
    loadApi () {
      var app = this

      app.$store.dispatch('loading/begin_loading')

      session.get('/api/userdata/place-annual-primary-energy-consumption/filters/').then(function (filtersResponse) {
        var data = filtersResponse.data

        app.yearsList = data.years
        app.displayFilters.selectedYear = app.yearsList[0]

        app.functionsList = data.functions
        app.functionsList.forEach(function (f) {
          app.displayFilters.selectedFunctions.push(f.id)
        })

        app.energiesList = data.energies
        app.energiesList.forEach(function (e) {
          app.displayFilters.selectedEnergies.push(e.id)
        })

        app.tagsList = data.tags
      }).then(function (response) {
        app.$store.dispatch('loading/end_loading')
      })
    },
    getRadius: function (item, bounds) {
      let x = parseFloat(item.shon)

      let radius = ((mapMarkerSizes.max - mapMarkerSizes.min) / (bounds.max - bounds.min)) * x + mapMarkerSizes.min
      return radius
    },
    getConsumptionColor: function (item, bounds) {
      return consumptionClassColors[item.energy_class_level]
    },
    getCostColor: function (item, bounds) {
      let rainbow = new Rainbow()
      rainbow.setSpectrum('#d9d9f0', '#00009c')
      rainbow.setNumberRange(bounds.min, bounds.max)
      return '#' + rainbow.colourAt(item.total_cost)
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../stylesheets/variables";

.page-content {
  overflow: auto;
  height: calc(100vh - 64 * 2px);
}

.page-layout {
  display: flex;
  height: min-content;
}

.filters__panel {
  background-color: darken(project-theme("white"), 4);
  border-left: 1px solid darken(project-theme("white"), 10);
  padding: 20px;
  right: 0;
  bottom: 0;
  top: 64px;
  width: 25%;
}

.main__panel {
  padding: 20px;
  width: 75%;
  display: flex;
  flex-direction: column;
  > div {
    margin-bottom: 20px;
  }
}
.chart {
  position: relative;
  padding-top: 80px;
  display: flex;
  width: 100%;
}

.p-10 {
  padding: 20px 40px !important;
  position: relative;
  &::before {
    content: "";
    position: absolute;
    width: 20px;
    height: 100%;
    background: #86ad19;
    left: 0;
    top: 0;
  }
}
>>> #chartjs-tooltip {
  background-color: #eee;
  h3 {
    color: #86ad19;
  }
  h4 {
    margin-top: 5px;
    margin-bottom: 0;
    border-top: 1px solid #eee;
    padding-top: 5px;
  }
  .footer {
    text-align: center;
    padding-top: 1rem;
    padding-bottom: 1rem;
    border-top: 1px solid #eee;
    margin-top: 1rem;
  }
  .md-button{
    background-color: #86ad19;
    color: #fff;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/BuildingStockSummary.vue